import { callApiWithAuthorization } from "../CallApi";

export async function createPortal(properties) {
	const request = await callApiWithAuthorization("/api/v0/portal", {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(properties)
	});
	const response = await request.json();
	return response;
}

export async function updatePortal(portalId, properties) {
	const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(properties)
	});
	const response = await request.json();
	return response;
}

export async function deletePortal(projectId, portalId, portalName) {
	const request = await callApiWithAuthorization("/api/v0/portal/" + projectId + "/" + portalId + "/" + portalName, {
		method: "DELETE",
		headers: {
			"Content-Type": "application/json",
		},
	});
	const response = await request.json();
	return response;
}

export async function getPortals(projectId) {
	try {
		let request = await callApiWithAuthorization("/api/v0/portals/" + projectId)
		return await request.json()
	} catch (error) {
		return error
	}
}

export async function getPortal(portalId) {
	const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}`);
	const response = await request.json();
	return response;
}

export async function getMenuItems(portalId) {
	const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/menu-items`);
	const response = await request.json();
	return response;
}

export async function getPortalEntityTargetPage(portalId, entityId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/entity/${entityId}/targetPages`);
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

export async function createItem(projectId, portalId, properties) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/menu-item`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				...properties,
				projectId
			})
		});
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

export async function updateItem(portalId, menuItemId, properties, childId = "") {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/menu-item/${menuItemId}?itemId=${childId}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(properties)
		});
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

export async function deleteItem(portalId, menuItemId, childItemId = "") {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/menu-item/${menuItemId}?itemId=${childItemId}`, {
			method: "DELETE"
		});
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

export async function reorderItems(portalId, items) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/menu-items`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(items)
		});
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

export async function updatePortalTargetPage(portalId, targetPageId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/target-page`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ targetPageId })
		});
		const response = await request.json();
		return response;
	} catch (e) {
		return e.message;
	}
}

// This is strictly for use in RealtimeAPIChatbox.jsx
// Only for AI use case. Do not use elsewherem unless 100% sure.
export async function reorderMenuItems(portalId, items) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/reorder-items`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ items })
		});
		const response = await request.json();
		return response;
	} catch (e) {
		throw new Error(e.message);
	}
}